export const MAX_UPLOAD_SIZE = 10 ** 7;
export const HUMAN_READABLE_UPLOAD_SIZE = `${Math.floor(MAX_UPLOAD_SIZE / 10 ** 6)}MB`;

export const providerProfileLabels = {
  about: 'About Me',
} as const;
